module.exports = __webpack_public_path__ + "img/hr-deepwater-green-side.49ca214c.png";